import DisplayImage from "@/components/common/DisplayImage/DisplayImage";

export type IMediaIconAttrs = {
  mediaUrl?: string;
  mediaAlt?: string;
  mediaSize?: string;
};

// SVGs that carry only a viewBox have no width/height to read, so mediaSize can
// come through unparseable. next/image needs real numbers, and the DS sizes the
// icon slot in CSS anyway, so a square fallback keeps the page rendering.
const FALLBACK_SIZE = 40;

const parseSize = (value?: string) => {
  const size = Number.parseInt(value ?? "", 10);
  return Number.isNaN(size) ? FALLBACK_SIZE : size;
};

export const mediaIconElement = ({
  mediaUrl,
  mediaAlt,
  mediaSize,
}: IMediaIconAttrs) => {
  if (!mediaUrl) return undefined;

  const size = mediaSize ? mediaSize.split("x") : [];

  return (
    <DisplayImage
      url={mediaUrl}
      alt={mediaAlt}
      width={parseSize(size[0])}
      height={parseSize(size[1])}
    />
  );
};
